import React, { useEffect, useMemo, useState } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import { Input, Select } from "antd";
import { postApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import toast from "react-hot-toast";
import SelectList from "../../../components/common/SelectList";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";
const CreateStandardForms = ({ onOpen, onClose, onSave }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [selectedRole, setselectedRole] = useState([]);
const [popup, setPopup] = useState({
    open: false,
    type: "",
    title: "",
    message: "",
  });
  const [errorMessage, setErrorMessage] = useState({
    title: "",
    description: "",
  });

  const selectRoleList = useMemo(
    () => [
      { label: "EMPLOYEE", value: "employee" },
      { label: "VENDOR", value: "vendor" },
      // {
      //   label: "LOCATION USER",
      //   value: "location_user",
      // },
      {
        label: "USER",
        value: "user",
      },
      // { label: "LOCATION ADMIN", value: "location_admin" },
      // { label: "SUB ADMIN", value: "sub_admin" },
      // { label: "GROUP ADMIN", value: "group_admin" },
    ],
    []
  );
useEffect(() => {
    if (popup.open) {
      const timer = setTimeout(() => {
        setPopup((prev) => ({
          ...prev,
          open: false,
        }));
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [popup.open]);
  const createStandardForm = async (data) => {
  
      const response = await postApi({
        apiUrl: API_URLS.CREATE_STANDARDFORMS,
        data,
      });
      if (response?.success) {
        // toast.success(
        //   `Standard Form Created Successfully with name: ${data.title}`
        // );
        onSave();
      }else{
      setPopup({
        open: true,
        type: "error",
        title: "Failed",
        message: response?.message || "Failed to create standard form",
      })
        
    }
    
  };

  const handleSelectedFormChange = (value) => {
    setselectedRole((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const handleSave = async () => {
    let isValid = true;
    const errors = { title: "", description: "", selectedRole: "" };

    if (!title) {
      errors.title = "title is required";
      isValid = false;
    }

    if (!description) {
      errors.description = "description is required";
      isValid = false;
    }

    // if (!status) {
    //   errors.status = "status is required";
    //   isValid = false;
    // }

    if (selectedRole.length === 0) {
      errors.selectedRole = "Select Role is required";
      isValid = false;
    }

    setErrorMessage(errors);

    if (isValid) {
      const data = {
        title: title,
        description: description,
        role_type: selectedRole,
      };
      await createStandardForm(data);
    }
  };

  const handleCancel = () => {
    setTitle("");
    setDescription("");

    const errors = { title: "", description: "", selectedRole: [] };
    onClose();
  };

  
  return (
    <div>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
        <div>
          <h3 className=" text-xl text-[#06513D]">Create New</h3>
        </div>

        <div className="flex flex-col mt-6 border rounded-lg  p-5 gap-6">
          <Input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Form Name"
            className="h-14 rounded-lg"
          />
          {errorMessage.title && (
            <div className="text-red-500 text-sm">{errorMessage.title}</div>
          )}

          <Input.TextArea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Description"
            className="rounded-lg"
            rows={4}
          />

          {errorMessage.description && (
            <div className="text-red-500 text-sm">
              {errorMessage.description}
            </div>
          )}

          {/* <Select
            value={status || undefined}
            onChange={(value) => setStatus(value)}
            placeholder="Status"
            className="h-14 rounded-lg"
            options={[
              { label: "Approved", value: "Approved" },
              { label: "Inactive", value: "Inactive" },
              { label: "Sent for Approval", value: "Sent for Approval" },
              { label: "Draft", value: "Draft" }
            ]}
          />
          {errorMessage.status && (
            <div className="text-red-500 text-sm">{errorMessage.status}</div>
          )} */}

          <p className=" text-lg mt-4  text-[#06513D]">Role Type</p>
          <div className="border px-4 rounded-lg">
            <SelectList
              list={selectRoleList}
              //   title="Select Form"
              paddingRequired={false}
              selecteditems={selectedRole}
              onChange={handleSelectedFormChange}
              selectionType="checkbox"
            />
            {errorMessage.selectedRole && (
              <div className="text-red-500 text-sm">
                {errorMessage.selectedRole}
              </div>
            )}
          </div>
        </div>

        <div className="flex justify-center px-20 gap-10 p-5">
          <CustomButton
            buttonType="button"
            variant="cancel"
            buttonText="Cancel"
            onClick={handleCancel}
            className="text-base font-normal h-[50px] w-[200px]"
          />
          <CustomButton
            buttonType="button"
            variant="ok"
            buttonText="Save"
            onClick={handleSave}
            className="text-base font-normal h-[50px] w-[200px]"
          />
        </div>
      </DailogBox>
      {popup.open && (
              <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20">
                <PopupCard
                  type={popup.type}
                  title={popup.title}
                  message={popup.message}
                />
              </div>
            )}
    </div>
  );
};

export default CreateStandardForms;
